<template>
  <div>
    <OverlayNetSign :overlaynet="overlaynet" />
    <v-app
      :style="{
        'background-image': 'url(' + require('@/assets/bg.jpg') + ')',
      }"
      style="background-size: cover"
    >
      <v-container class="fill-height" fluid>
        <v-card class="mx-auto" width="1000">
          <v-card-text>
            <v-row class="pt-3">
              <v-col cols="12" md="6" lg="6" xs="12" xl="6" sm="12">
                <v-img
                  max-width="100%"
                  max-height="1800px"
                  class="mt-n3"
                  src="@/assets/Prezencenew2.png"
                  @click="showLog"
                >
                </v-img>
              </v-col>
              <v-col cols="12" md="6" lg="6" xs="12" xl="6" sm="12">
                <v-form ref="form">
                  <v-text-field
                    v-model="memberName"
                    outlined
                    :rules="rulesMembers"
                    dense
                    class="ml-6 mr-6"
                    label="Member Name*"
                  />
                  <v-text-field
                    v-model="OrganistionName"
                    outlined
                    :rules="org_name_rules"
                    :disabled="checkmember == false"
                    dense
                    class="ml-6 mr-6"
                    label="Organization Name*"
                  />
                  <!-- @change="check_orgnisationName()"
                    @keydown.enter="check_orgnisationName()"
                    @blur="check_orgnisationName()" -->
                  <v-card-actions class="mt-n6"
                    ><v-spacer />
                    <v-btn
                      text
                      class="green--text text-capitalize"
                      v-if="orgCheckv2 == true"
                    >
                      <v-icon class="mr-1" color="success"
                        >mdi-check-circle</v-icon
                      >
                      verified</v-btn
                    >
                  </v-card-actions>
                  <v-btn
                    small
                    class="white--text ml-6"
                    color="gradient-bg"
                    :disabled="checkorg == false || checkmember == false"
                    @click="openmap()"
                    >Select Location</v-btn
                  >

                  <v-textarea
                    v-model="Organistionaddress"
                    outlined
                    dense
                    :disabled="
                      checkorg == false ||
                      checkmember == false ||
                      geocheck == false
                    "
                    :rules="address_rules"
                    height="80px"
                    class="ml-6 mr-6 mt-4"
                    label="Organization Address*"
                  />
                  <!-- :rules="address_rules" -->
                  <v-row>
                    <v-col cols="6">
                      <v-autocomplete
                        dense
                        outlined
                        :search-input.sync="searchL"
                        v-model="countryNamelist"
                        hide-no-data
                        :disabled="
                          checkorg == false ||
                          checkmember == false ||
                          geocheck == false
                        "
                        hide-selected
                        :items="countryitems"
                        item-text="text"
                        item-value="value"
                        class="ml-6 mt-n1"
                        label="Country*"
                        return-object
                        @change="updateStates"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-autocomplete
                        dense
                        outlined
                        :search-input.sync="searchstate"
                        v-model="stateNamelist"
                        hide-no-data
                        :disabled="
                          checkorg == false ||
                          checkmember == false ||
                          geocheck == false
                        "
                        item-text="name"
                        item-value="name"
                        hide-selected
                        :items="filteredStates"
                        class="mr-6 mt-n1"
                        label="State*"
                      />
                    </v-col>
                  </v-row>
                  <v-text-field
                    dense
                    outlined
                    v-model="email"
                    :disabled="
                      checkorg == false ||
                      geocheck == false ||
                      checkmember == false ||
                      checkaddress == false
                    "
                    :rules="email_rules"
                    append-icon="mdi-email"
                    class="ml-6 mr-6"
                    label="Email*"
                  />

                  <v-card-actions class="mt-n6"
                    ><v-spacer /><v-btn
                      v-if="checkno == false"
                      v-show="isEmailValid"
                      :disabled="
                        checkorg == false ||
                        geocheck == false ||
                        checkmember == false ||
                        checkaddress == false
                      "
                      x-small
                      :loading="emailload"
                      class="gradient-bg white--text mr-3 text-capitalize"
                      @click="signUpCheck"
                      >verify
                    </v-btn>
                    <v-btn
                      text
                      class="green--text text-capitalize"
                      v-if="checkno == true"
                    >
                      <v-icon class="mr-1" color="success"
                        >mdi-check-circle</v-icon
                      >
                      verified</v-btn
                    >
                  </v-card-actions>
                  <v-row>
                    <v-col cols="4">
                      <v-select
                        label="Country Code *"
                        v-model="CountryCode"
                        :items="CountryList"
                        item-value="phonecode"
                        :disabled="
                          checkorg == false ||
                          geocheck == false ||
                          checkmember == false ||
                          checkaddress == false ||
                          checkno == false
                        "
                        item-text="name"
                        class="ml-6"
                        dense
                      >
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.flag }} ({{
                            item.phonecode.toString().includes("+") == false
                              ? "+" + item.phonecode
                              : item.phonecode
                          }})
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          {{ item.flag }} {{ item.name }} ({{ item.phonecode }})
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="8">
                      <v-text-field
                        dense
                        outlined
                        v-model="PhoneNumber"
                        :rules="numberRules"
                        class="mr-6"
                        label="Phone Number*"
                      />
                    </v-col>
                  </v-row>

                  <v-card-actions class="mt-n9"
                    ><v-spacer /><v-btn
                      v-show="isnumberValid"
                      x-small
                      :loading="phloading"
                      @click="checkorgname"
                      id="sign-in-button"
                      class="gradient-bg white--text text-capitalize mr-3"
                      >verify
                    </v-btn>
                  </v-card-actions>
                  <!-- open_phonenumberdailog -->
                </v-form>
                <v-card-actions class="justify-center">
                  <v-btn
                    class="gradient-bg white--text mt-n2"
                    width="180px"
                    disabled
                    small
                    >Sign Up</v-btn
                  >
                </v-card-actions>
                <v-row no-gutters class="justify-center">
                  <div>
                    Already a user ?
                    <v-btn x-small text color="#ef3f6e" @click="back_tologin()"
                      ><b><u>Login</u></b></v-btn
                    >
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-dialog v-model="geoproof" persistent width="500px">
          <v-toolbar dense class="elevation-0 gradient-bg white--text">
            <v-toolbar-title>Location </v-toolbar-title>
            <v-spacer />
            <v-icon @click="close_dialog()" class="white--text mr-n3"
              >mdi-close</v-icon
            >
          </v-toolbar>
          <v-card>
            <v-card-text>
              <gmap-autocomplete
                placeholder="Search Location"
                :value="search"
                ref="clearSearch"
                class="ml-1 mb-6 mt-5"
                style="
                  border-bottom: 1px solid grey;
                  font-size: 18px;
                  width: 290px;
                "
                @place_changed="setPlace"
              ></gmap-autocomplete>
              <v-btn
                rounded
                small
                class="white--text ml-6"
                color="gradient-bg"
                @click="addMarker"
                >Go</v-btn
              >
              <v-btn
                class="white--text ml-2"
                color="gradient-bg"
                small
                :disabled="geocheck == false"
                @click="close_dialog()"
              >
                Save
              </v-btn>
              <GmapMap
                :center="
                  markers[0] != undefined ? markers[0].position : defaultCenter
                "
                :zoom="20"
                map-type-id="terrain"
                style="height: 300px"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @dragend="callposition"
                  @click="center = m.position"
                />
              </GmapMap>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </v-app>
    <div v-if="componentcheck == 1">
      <PhoneNumberverification
        :otpverificarionNumber="otpverificarionNumber"
        :phoneitems="phoneitems"
        :onboardItems="onboardItems"
        @clicked="close_prop"
        v-on:errorMsg="errorPop"
        v-on:successMsg="sucessPop"
        :sessiondata="sessiondata"
      />
    </div>
    <div v-if="componentcheck == 2">
      <EmailVerification
        :emailotp="emailotp"
        @clicked="close_prop"
        :emailitems="emailitems"
        :userDetails="userDetails"
        v-on:errorMsg="errorPop"
        v-on:verification="verficationsucess"
        v-on:successMsg="sucessPop"
      />
    </div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
  </div>
</template>

<script>
/* eslint-disable */

import { checkMobExits } from "@/graphql/queries.js";
import { GenVerifyOtp } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

import Snackbar from "@/components/SnackBar.vue";
import EmailVerification from "../../components/Dialogs/EmailVerification.vue";
import PhoneNumberverification from "../../components/Dialogs/PhoneNumberverification.vue";
import { Country, State } from "country-state-city";
import OverlayNetSign from "@/components/OverlayNetSign.vue";

import * as usertz from "user-timezone";
import { Auth } from "aws-amplify";
export default {
  components: {
    Snackbar,
    // Overlay,
    EmailVerification,
    PhoneNumberverification,
    OverlayNetSign,
  },
  data() {
    return {
      email: "",
      memberName: "",
      search: "",
      emailotp: false,
      componentcheck: 0,
      SnackBarComponent: {},
      emailitems: {},
      onboardItems: {},
      phoneCode: "",
      searchstate: "",
      otpverificarionNumber: false,
      orgCheckv2: false,
      emailload: false,
      checkno: false,
      emailCode: "",
      PhoneNumber: "",
      OrganistionName: "",
      Organistionaddress: "",
      latt: "",
      checkorg: false,
      phloading: false,
      checkaddress: false,
      longg: "",
      CountryList: [],
      phoneitems: {},
      countryitems: [],
      orgloading: false,
      geocheck: false,
      CountryCode: "",
      countryNamelist: "IN",
      stateNamelist: "Karnataka",
      new_timezone: "",
      geoproof: false,
      countryName: "",
      searchL: "",
      currentPlace: "",
      sessiondata: "",
      overlaynet: false,
      checkmember: false,
      userDetails: {},
      states: [],
      filteredStates: [],
      defaultCenter: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      numberRules: [
        (x) => x.trim() != "" || "Contact Number cannot be empty",
        (v) => /^[0-9]{8,15}$/.test(v) || "Contact Number must be valid",
      ],
      email_rules: [(v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
      rulesMembers: [
        (v) => v.trim().length != 0 || "Member Name cannot be empty",
        (v) =>
          /^[a-z\sA-Z]{3,30}$/.test(v) ||
          "3 - 30 characters, no special characters, no numbers ",
      ],
      org_name_rules: [
        (v) => v.trim().length != 0 || "Organization Name cannot be empty",
        (v) =>
          /^[a-zA-Z0-9\s]{3,80}$/.test(v) ||
          "3 - 80 characters, no special characters",

        (v) =>
          v.length >= 3 ||
          "Organization Name must contain more than 3 characters",
        (v) =>
          v.length <= 80 ||
          "Organization Name cannot exceed more than 50 characters",
      ],
      otp_rules: [
        (v) => v.length != 0 || "OTP cannot be empty",
        (v) => v.length == 6 || "Enter Correct OTP",
      ],
      address_rules: [
        (v) => v.trim().length != 0 || "Organization Address cannot be empty",
        // (v) =>
        //   v.length >= 3 ||
        //   "Organization Address must contain more than 3 characters",
        (v) =>
          v.length <= 300 ||
          "Organization Address cannot exceed more than 300 characters",
      ],
    };
  },
  computed: {
    isEmailValid() {
      // You can implement your own logic to check the email validity based on your email_rules.
      // For example, you can use a regular expression to validate the email format.
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.email);
    },
    isnumberValid() {
      // You can implement your own logic to check the email validity based on your email_rules.
      // For example, you can use a regular expression to validate the email format.
      const numberPattern = /^[0-9]{8,15}$/;
      return numberPattern.test(this.PhoneNumber);
    },
  },
  watch: {
    // OrganistionName(val) {
    //   if (this.checkorg == true) {
    //     if (val) {
    //       this.checkorg = false;
    //     }
    //   }
    // },
    OrganistionName(val) {
      if (val.length > 3) {
        this.checkorg = true;
      } else {
        this.checkorg = false;
      }
    },
    memberName(val) {
      if (
        val.trim().length > 2 &&
        this.rulesMembers.every((rule) => rule(val))
      ) {
        this.checkmember = true; // Set check to true
      } else {
        this.checkmember = false; // Set check to false if not meeting criteria
      }
    },
    Organistionaddress(val) {
      if (
        val.trim().length > 3 &&
        this.address_rules.every((rule) => rule(val))
      ) {
        this.countryNamelist = "IN";
        this.checkaddress = true; // Set check to true
      } else {
        this.countryNamelist = "IN";
        this.checkaddress = false; // Set check to false if not meeting criteria
      }
    },
    // PhoneNumber(val) {
    //   if (this.checkno == true) {
    //     if (val) {
    //       this.checkno = false;
    //     }
    //   }
    // },
  },
  created() {
    this.CountryList = Country.getAllCountries();
    this.countryitemsnew = Country.getAllCountries();
    this.states = State.getAllStates();

    fetch(
      "https://api.geoapify.com/v1/ipinfo?apiKey=7dc7ae8d1cc54ab2ae3753110b2a7726"
    )
      .then((resp) => resp.json())
      .then((userLocationData) => {
        this.CountryName = userLocationData.country.name;
        var self = this;
        // console.log(self.CountryList);
        self.CountryList.forEach(function (CountryIDX) {
          if (CountryIDX.name == userLocationData.country.name) {
            self.CountryCode = CountryIDX.phonecode;
          }
        });
        self.countryitemsnew.forEach((element) => {
          self.countryitems.push({
            text: element.name,
            value: element.isoCode,
          });
        });

        // self.countryitemsnew.forEach(function (CountryIDX) {
        //   if (CountryIDX.name == userLocationData.country.name) {
        //     self.countryNamelist = CountryIDX.name;
        //   }
        // });
        self.countryNamelist = "IN";
      });
    this.countryfilter();
    this.checkInternet();
    this.geoFindMe();
  },
  methods: {
    async checkemailValidate() {
      this.emailload = true;
      try {
        let result = await API.graphql(
          graphqlOperation(checkMobExits, {
            input: {
              action_type: "WEB_EMAIL",
              user_email_id: this.email,
            },
          })
        );
        this.emailload = false;
        var response = JSON.parse(result.data.checkMobExits);
        if (response.Status == "SUCCESS") {
          this.generate_otp();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Email ID already exists",
          };
        }
      } catch (err) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: err.errors[0].message,
        };
      }
    },
    async checkorgname() {
      this.phloading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(checkMobExits, {
            input: {
              action_type: "ORGANISATION_NAME",
              organisation_name: this.OrganistionName.trim(),
            },
          })
        );
        this.phloading = false;
        var response = JSON.parse(result.data.checkMobExits);
        if (response.Status == "SUCCESS") {
          this.orgCheckv2 = true;
          this.checkPhoneValidate();
        } else {
          this.orgCheckv2 = false;
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Organization name already exists",
          };
        }
      } catch (err) {
        this.orgCheckv2 = false;
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: err.errors[0].message,
        };
      }
    },
    async checkPhoneValidate() {
      this.phloading = true;
      let phoneNo = "+" + this.CountryCode + this.PhoneNumber;
      console.log("phoneNo", phoneNo)
      try {
        let result = await API.graphql(
          graphqlOperation(checkMobExits, {
            input: {
              action_type: "PHONE",
              user_full_contact_number:
                "+" + this.CountryCode + this.PhoneNumber,
            },
          })
        );
        this.phloading = false;
        var response = JSON.parse(result.data.checkMobExits);
        if (response.Status == "SUCCESS") {
          this.phoneCheckv2();
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Phone number already exists",
          };
        }
      } catch (err) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: err.errors[0].message,
        };
      }
    },
    updateStates() {
      this.filteredStates = [];
      this.stateNamelist = "";
      this.filteredStates = this.states.filter(
        (state) => state.countryCode === this.countryNamelist.value
      );
    },
    countryfilter() {
      this.filteredStates = [];

      this.filteredStates = this.states.filter(
        (state) => state.countryCode === this.countryNamelist
      );
    },

    showLog() {
      window.location.href = "https://www.prznce.com/";
    },
    close_prop(val) {
      if (val == 0) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          Top: true,
          timeout: 5000,
          SnackbarText: "Login Successfully!!",
        };
        this.emailotp = false;
        this.$router.push("/Dashboard");
      } else if (val == 1) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: "Invalid OTP",
          timeout: 5000,
          Top: true,
        };
      } else if (val == 2) {
        this.otpverificarionNumber = false;
        this.emailotp = false;
      } else if (val == 3) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "green",
          SnackbarText: "OTP Sent Successfully",
          timeout: 5000,
          Top: true,
        };
      } else if (val == 4) {
        this.otpverificarionNumber = false;
        this.checkno = true;
      }
    },
    geoFindMe() {
      const timezone = usertz.getTimeZone();
      // console.log(timezone,'timezone');
      this.new_timezone = timezone.includes("/")
        ? timezone.split("/")[1]
        : timezone;
      this.CountryList = Country.getAllCountries();
      fetch(
        "https://api.geoapify.com/v1/ipinfo?apiKey=7dc7ae8d1cc54ab2ae3753110b2a7726"
      )
        .then((resp) => resp.json())
        .then((userLocationData) => {
          this.CountryName = userLocationData.country.name;
        });
      // console.log(  this.CountryName);
      // console.log(this.new_timezone);
    },
    errorPop(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "red",
        Top: true,
        SnackbarText: val,
      };
    },
    verficationsucess(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        Top: true,
        SnackbarText: "otp verified successfully!",
      };
      this.emailotp = false;
      this.otpverificarionNumber = false;
      this.checkno = true;
    },
    sucessPop(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        Top: true,
        SnackbarText: val,
      };
      this.otpverificarionNumber = false;
      this.checkno = true;
    },

    callposition(latLng) {
      this.markers = [];
      var marker = {
        lat: latLng.latLng.lat(),
        lng: latLng.latLng.lng(),
      };
      this.markers.push({ position: marker });
      (this.latt = marker.lat), (this.longg = marker.lng);
    },
    openmap() {
      this.geoproof = true;
    },
    close_dialog() {
      this.geoproof = false;
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      this.Organistionaddress = this.currentPlace.formatted_address;
      this.markers = [];
      var marker = {
        lat: this.currentPlace.geometry.location.lat(),
        lng: this.currentPlace.geometry.location.lng(),
      };
      this.markers.push({ position: marker });
      (this.latt = marker.lat), (this.longg = marker.lng);
      this.geocheck = true;
      const geocoder = new google.maps.Geocoder();
      const latlng = this.markers[0].position;
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            const city = results[0].address_components.find((component) =>
              component.types.includes("locality")
            );
            console.log("City:", city ? city.long_name : "Not found");
          } else {
            console.log("No results found");
          }
        } else {
          console.log("Geocoder failed due to:", status);
        }
      });
    },

    async phoneCheckv2() {
      this.phloading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(GenVerifyOtp, {
            input: {
              action_type: "OTP_GENERATOR",
              contact_number: "+" + this.CountryCode + this.PhoneNumber,
            },
          })
        );
        this.phloading = false;
        var response = JSON.parse(result.data.GenVerifyOtp);
        if (response.Status == "SUCCESS") {
          this.onboardItems = {
            organisation_country:
              this.countryNamelist == "IN"
                ? "India"
                : this.countryNamelist.text,
            organisation_city: this.new_timezone,
            user_email_id: this.email,
            organisation_name: this.OrganistionName,
            organisation_address: this.Organistionaddress,
            user_contact_number: this.PhoneNumber,
            user_country_code: "+" + this.CountryCode,
            organisation_state: this.stateNamelist,
            user_name: this.memberName,
            onboarding_type: "PORTAL",
            geo_lat: this.latt,
            geo_long: this.longg,
          };
          this.sessiondata = response.session;
          this.$store.commit("snackbar/showMessage", {
            content: response.Message,
            color: "green",
          });
        }

        this.componentcheck = 1;
        this.otpverificarionNumber = true;
        // console.log(this.countrycode.one);
      } catch (err) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: err.errors[0].message,
        };
      }
    },

    async signUpCheck() {
      this.emailload = true;
      try {
        const { user } = await Auth.signUp({
          username: this.email,
          password: "Admin@123",
          attributes: {
            email: this.email, // optional
            // phone_number, // optional - E.164 number convention
            // other custom attributes
          },
          autoSignIn: {
            // optional - enables auto sign in after user is confirmed
            enabled: true,
          },
        });

        this.emailload = false;
        if (user) {
          this.emailload = false;
          this.generate_otp();
        }
      } catch (error) {
        if (
          error.message == "An account with the given email already exists."
        ) {
          this.relogin();
          // this.SnackBarComponent = {
          //   SnackbarVmodel: true,
          //   SnackbarColor: "red",
          //   SnackbarText: error.message,
          //   timeout: 5000,
          //   Top: true,
          // };
        }
      }
    },
    async relogin() {
      this.loading1 = true;

      const username = this.email;
      const password = "Admin@123"; // ⚠️ Replace with your actual hardcoded password

      try {
        const user = await Auth.signIn(username, password);

        if (user) {
          this.checkemailValidate();
        }
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: error.message || "Login failed",
          timeout: 5000,
          Top: true,
        };
        this.loading1 = false;
      }
    },

    async generate_otp() {
      var items = {
        organisation_country: this.countryNamelist,
        email: this.email,
        organisation_city: this.new_timezone,
        organisation_name: this.OrganistionName,
        organisation_address: this.Organistionaddress,
        user_contact_number: this.PhoneNumber,
        user_country_code: "+" + this.CountryCode,
        user_name: this.memberName,
        geo_lat: this.latt,
        geo_long: this.longg,
      };
      this.emailitems = items;
      try {
        const user = await Auth.signIn(this.email)
          .then((user) => {
            this.userDetails = user;

            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "green",
              SnackbarText: "OTP Sent Successfully",
              timeout: 5000,
              Top: true,
            };
            this.componentcheck = 2;
            this.emailotp = true;
            this.focusOnOTPField();
          })
          .catch((err) => {
            this.SnackBarComponent = {
              SnackbarVmodel: true,
              SnackbarColor: "red",
              SnackbarText: "Couldn't find your Prezence account!!",
              timeout: 5000,
              Top: true,
            };
          });
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          SnackbarText: error.message,
          timeout: 5000,
          Top: true,
        };
      }
    },
    focusOnOTPField() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[this.otpRef].focus();
        }, 100); // Adjust the delay as needed (100ms in this case)
      });
    },
    open_phonenumberdailog() {
      this.componentcheck = 1;
      this.otpverificarionNumber = true;
    },

    checkInternet() {
      this.network = setInterval(() => {
        this.checknetwork();
      }, 5000);
    },
    checknetwork() {
      var ifConnected = window.navigator.onLine;
      if (!ifConnected) {
        this.overlay = false;
        this.overlaynet = true;
      } else {
        this.overlaynet = false;
      }
    },
    back_tologin() {
      this.$router.push("/");

      // this.$router.push({
      //   name: "NewLogin",
      //   params: {
      //     otp: 1,
      //     email: this.email,
      //   },
      // });
    },
  },
};
</script>

<style>
</style>